/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S6_Li3Inputs */

const en_guide_large_json_files_s6_li3 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files <strong>50+ MB</strong>: Consider using command-line tools like <code>jq</code> instead`)
};

const ko_guide_large_json_files_s6_li3 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>50+ MB</strong> 파일: <code>jq</code> 같은 커맨드 라인 도구 사용을 고려`)
};

const ja_guide_large_json_files_s6_li3 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>50MB</strong>以上のファイル: <code>jq</code>などのコマンドラインツールの使用を検討`)
};

/**
* | output |
* | --- |
* | "Files <strong>50+ MB</strong>: Consider using command-line tools like <code>jq</code> instead" |
*
* @param {Guide_Large_Json_Files_S6_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s6_li3 = /** @type {((inputs?: Guide_Large_Json_Files_S6_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S6_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s6_li3(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s6_li3(inputs)
	return ja_guide_large_json_files_s6_li3(inputs)
});